'use client'

import { cn } from '@/lib/utils'
import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

const buttonVariants = cva(
  'inline-flex group cursor-pointer items-center justify-center whitespace-nowrap text-sm sm:text-base font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-orange-500 text-white hover:bg-orange-600',
        container: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
        outline:
          'border !border-accent-orange bg-transparent text-accent-orange hover:bg-orange-100'
      },
      size: {
        default: 'px-6 py-2 rounded-full w-fit'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  className?: string
  children: React.ReactNode
  showSvg?: boolean
}

const ButtonArrow = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, showSvg = false, variant, ...props }, ref) => {
    return (
      <button className={cn(buttonVariants({ variant, className }))} ref={ref} {...props}>
        {children}
        {showSvg && (
          <svg
            className='pl-3 transition-all duration-300 group-hover:ml-2'
            width='38'
            height='16'
            viewBox='0 0 38 16'
            fill='currentColor' // Sử dụng currentColor để ăn theo màu text
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M30.0754 15.9092L37.9431 8.18535C37.9799 8.14063 38 8.08447 38 8.02649C38 7.96852 37.9799 7.91233 37.9431 7.86761L30.0754 0.060533C30.0613 0.0417421 30.0431 0.0264804 30.0222 0.0159759C30.0012 0.00547149 29.9781 0 29.9547 0C29.9313 0 29.9082 0.00547149 29.8872 0.0159759C29.8663 0.0264804 29.848 0.0417421 29.834 0.060533L28.8609 1.11963L34.9409 7.1338H0.890111C0.64732 7.15637 0.421621 7.26885 0.257047 7.44928C0.092473 7.62971 0.000834731 7.86516 0 8.1097C0.00276417 8.22234 0.0283146 8.33326 0.0750929 8.4357C0.121871 8.53815 0.188918 8.62999 0.272148 8.70568C0.355379 8.78136 0.453032 8.83931 0.55926 8.87601C0.665488 8.9127 0.778058 8.92739 0.890111 8.91916H34.7824L28.8609 14.9712L29.834 15.9395C29.848 15.9583 29.8663 15.9735 29.8872 15.984C29.9082 15.9945 29.9313 16 29.9547 16C29.9781 16 30.0012 15.9945 30.0222 15.984C30.0431 15.9735 30.0613 15.9583 30.0754 15.9395V15.9092Z'
            />
          </svg>
        )}
      </button>
    )
  }
)

ButtonArrow.displayName = 'Button'

export { ButtonArrow, buttonVariants }
